import { MappedLink } from "@iewccouk/Services/CustomCategoryService";
import { CustomCategoriesStateType } from "@iewccouk/Store/State/Categories/CategoriesState";
import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: CustomCategoriesStateType = {
    categories: [],
};

export const customCategoriesReducer = createTypedReducer(initialState, {
    "Data/Categories/LoadCustomCategories": (
        draft: Draft<CustomCategoriesStateType>,
        { categories }: { categories: [] },
    ) => {
        return {
            ...draft,
            ...categories,
        };
    },
});
